var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel2022(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 785,
    height: 955,
    viewBox: "0 0 785 955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.201 80.0215C228.238 80.0336 228.274 80.0519 228.311 80.0641",
    stroke: "black",
    strokeWidth: 0.51574,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.029 159.118L241.066 159.1",
    stroke: "black",
    strokeWidth: 0.70997,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.718 70.7305C269.754 70.7426 269.791 70.7609 269.827 70.773",
    stroke: "black",
    strokeWidth: 0.51574,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M642.347 408.101C653.443 407.263 664.441 405.44 675.213 402.655C692.803 398.184 713.127 387.513 720.581 369.82C727.552 353.274 722.237 333.952 708.813 322.333C708.731 322.262 708.65 322.192 708.568 322.122C707.229 321.002 705.68 320.163 704.01 319.653C702.341 319.143 700.586 318.974 698.85 319.155C697.114 319.336 695.432 319.863 693.904 320.706C692.376 321.549 691.033 322.69 689.955 324.061C684.484 331.068 687.589 341.389 686.251 349.496C684.984 357.169 681.04 364.649 676.529 370.892C665.807 385.728 649.35 395.691 632.113 401.206C625.354 403.25 618.441 404.749 611.441 405.689C610.889 405.776 631.78 408.914 642.347 408.101Z",
    fill: "#8ECEDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M611.441 405.689C616.711 406.288 622.011 406.586 627.315 406.583C636.749 406.6 646.159 405.641 655.395 403.721C691.765 396.102 718.057 374.072 718.057 348.081C718.057 338.84 714.737 330.104 708.813 322.333C708.731 322.262 708.65 322.192 708.567 322.122C701.855 316.377 690.39 317.587 686.929 326.347C684.444 332.637 686.415 339.75 685.808 346.288C685.143 354.031 682.628 361.502 678.476 368.074C667.493 385.179 649.063 396.223 629.874 401.892C626.688 402.833 623.464 403.631 620.204 404.285C617.619 404.803 614.071 405.99 611.441 405.689Z",
    fill: "url(#paint0_linear_2_7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M639.556 527.576C650.652 528.414 661.65 530.237 672.422 533.022C690.012 537.493 710.336 548.164 717.79 565.857C724.761 582.403 719.446 601.725 706.022 613.344C705.94 613.415 705.858 613.485 705.776 613.555C704.438 614.675 702.889 615.514 701.219 616.024C699.55 616.534 697.795 616.703 696.059 616.522C694.323 616.341 692.641 615.814 691.113 614.971C689.585 614.128 688.242 612.987 687.164 611.616C681.693 604.609 684.798 594.288 683.46 586.181C682.193 578.508 678.249 571.028 673.738 564.785C663.016 549.949 646.559 539.986 629.322 534.471C622.563 532.427 615.65 530.928 608.65 529.988C608.098 529.901 628.989 526.763 639.556 527.576Z",
    fill: "#8ECEDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M608.65 529.988C613.92 529.389 619.22 529.091 624.524 529.094C633.958 529.077 643.368 530.036 652.604 531.956C688.974 539.575 715.266 561.605 715.266 587.596C715.266 596.837 711.946 605.574 706.022 613.344C705.94 613.415 705.859 613.485 705.776 613.555C699.064 619.3 687.599 618.09 684.138 609.33C681.653 603.04 683.624 595.927 683.017 589.389C682.352 581.646 679.837 574.175 675.685 567.603C664.702 550.498 646.272 539.454 627.083 533.785C623.896 532.844 620.673 532.046 617.413 531.392C614.828 530.874 611.28 529.687 608.65 529.988Z",
    fill: "url(#paint1_linear_2_7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.614 155.205C186.608 154.925 186.602 155.485 186.614 155.205V155.205Z",
    fill: "#205F88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.056 248.42C117.655 261.938 152.157 273.208 127.842 222.714C127.841 222.714 127.84 222.714 127.84 222.714C127.839 222.713 127.838 222.713 127.838 222.712C127.837 222.712 127.837 222.711 127.836 222.71C127.836 222.71 127.836 222.709 127.836 222.708C121.384 208.887 118.481 193.677 119.388 178.454C121.772 137.742 147.079 119.041 150.339 138.076C152.265 150.186 155.738 162 160.672 173.229C177.178 209.603 182.768 184.171 187.609 153.362L187.615 154.206C188.399 138.799 207.199 109.648 231.362 109.648C242.455 107.917 253.835 113.421 264.369 122.68C278.777 135.336 291.603 155.008 299.954 172.81C279.981 123.993 247.85 78.3287 216.413 65.8617C199.467 57.784 180.423 55.1777 161.927 58.4048C143.43 61.6318 126.399 70.532 113.197 83.8696C112.236 85.0179 111.299 86.1844 110.381 87.3569C103.673 96.2298 97.797 105.701 92.8283 115.651C70.678 158.502 77.8425 215.533 106.056 248.42Z",
    fill: "url(#paint2_linear_2_7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.12 108.697C325.58 184.666 331.074 268.53 317.461 296.316C303.231 325.362 245.209 277.128 256.139 316.774C271.596 372.82 325.759 405.824 376.859 425.345C429.892 445.603 490.221 458.545 547.169 458.545H547.284C633.318 457.172 704.489 419.225 720.892 369.144C716.847 381.494 702.303 391.197 691.384 396.375C657.654 412.37 611.21 408.372 576.403 398.186C537.409 386.774 504.064 361.318 483.704 326.262C471.875 305.915 460.55 279.657 448.532 251.563C435.48 221.052 421.608 188.384 405.381 158.778C395.317 137.701 382.142 118.253 366.299 101.084C296.898 25.796 198.931 1.26292 124.67 71.6178L118.68 77.6022C146.991 52.0606 217.182 30.6078 272.12 108.697Z",
    fill: "url(#paint3_linear_2_7)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.107 83.8695C126.309 70.5319 143.341 61.6317 161.838 58.4047C180.334 55.1776 199.377 57.7839 216.324 65.8615C247.761 78.3286 279.892 123.992 299.865 172.809C303.623 180.56 306.576 188.675 308.677 197.027C319.698 231.615 322.097 268.902 316.423 289.327C313.09 301.322 308.569 305.363 303.294 305.975C310.876 306.471 315.635 301.569 318.372 295.317C333.881 259.89 326.491 183.666 273.031 107.698C218.093 29.6087 147.902 51.0615 119.591 76.6031C119.585 76.6092 119.572 76.6153 119.566 76.6274C117.322 78.9969 115.169 81.4109 113.107 83.8695Z",
    fill: "#65C2D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M600.416 379.193C622.187 379.193 639.836 361.563 639.836 339.815C639.836 318.067 622.187 300.437 600.416 300.437C578.646 300.437 560.997 318.067 560.997 339.815C560.997 361.563 578.646 379.193 600.416 379.193Z",
    fill: "url(#paint4_linear_2_7)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M423.043 382.881C423.044 382.881 423.046 382.881 423.047 382.88C423.048 382.88 423.049 382.879 423.05 382.878C423.051 382.877 423.052 382.876 423.052 382.875C423.053 382.873 423.053 382.872 423.053 382.871C423.053 382.87 423.053 382.868 423.054 382.867C423.054 382.866 423.055 382.865 423.056 382.864C423.057 382.863 423.058 382.862 423.059 382.862C423.06 382.861 423.062 382.861 423.063 382.861",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M720.252 571.332C713.961 550.076 687.083 536.4 667.752 533.776C600.416 524.636 539.733 528.814 497.352 573.452C473.109 598.986 453.17 646.879 439.297 683.719C423.279 726.252 390.852 772.773 381.052 728.379C349.83 587.066 330.81 799.484 241.066 879.008C165.903 945.611 49.0859 890.464 84.8414 771.152C85.1308 770.186 85.4689 769.234 85.8023 768.278C120.782 668.023 211.242 592.901 305.932 540.406C329.407 527.408 354.048 516.632 379.532 508.22C407.682 498.92 441.332 488.74 459.362 485.334C483.842 480.605 508.709 478.163 533.642 478.042H533.732C627.562 479.45 704.852 519.288 720.252 571.332Z",
    fill: "url(#paint5_linear_2_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_7",
    x1: 611.441,
    y1: 362.593,
    x2: 718.057,
    y2: 362.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C4C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21543,
    stopColor: "#105E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64345,
    stopColor: "#1C8BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_7",
    x1: 608.65,
    y1: 573.084,
    x2: 715.266,
    y2: 573.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C4C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21543,
    stopColor: "#105E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64345,
    stopColor: "#1C8BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_7",
    x1: -12.9021,
    y1: 158.473,
    x2: 404.045,
    y2: 158.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26B6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35655,
    stopColor: "#1C8BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78457,
    stopColor: "#105E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C4C82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_7",
    x1: 118.68,
    y1: 244.218,
    x2: 720.892,
    y2: 244.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49069,
    stopColor: "#26B6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56019,
    stopColor: "#30B9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68036,
    stopColor: "#4DBFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83676,
    stopColor: "#7ACBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1D89E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_7",
    x1: 532.106,
    y1: 339.815,
    x2: 636.945,
    y2: 339.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C4C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00921,
    stopColor: "#0D4F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18681,
    stopColor: "#187BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34558,
    stopColor: "#1F9BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47837,
    stopColor: "#24AFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5689,
    stopColor: "#26B6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62773,
    stopColor: "#30B9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72945,
    stopColor: "#4DBFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86182,
    stopColor: "#7ACBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1D89E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_7",
    x1: -8.50892,
    y1: 692.843,
    x2: 685.108,
    y2: 692.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C4C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00851,
    stopColor: "#0D4F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17261,
    stopColor: "#187BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31931,
    stopColor: "#1F9BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#24AFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52565,
    stopColor: "#26B6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59038,
    stopColor: "#30B9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7023,
    stopColor: "#4DBFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84796,
    stopColor: "#7ACBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1D89E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel2022);
export default __webpack_public_path__ + "static/media/excel2022.932cc8102da68199bc0f34683e7527c1.svg";
export { ForwardRef as ReactComponent };